var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: (_vm.prefixCls + "-tree-node")
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.node.visible),
      expression: "node.visible"
    }],
    class: [(_vm.prefixCls + "-tree-data"), _vm.tree.store.currentNode === _vm.node ? (_vm.prefixCls + "-tree-active") : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleClick($event)
      }
    }
  }, [_c('div', {
    class: (_vm.prefixCls + "-tree-node__content"),
    style: ({
      'padding-left': (_vm.node.level - 1) * 20 + 'px'
    })
  }, [_c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleExpandIconClick($event)
      }
    }
  }, [_c('n3-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.node.isLeaf),
      expression: "!node.isLeaf"
    }],
    class: (_vm.prefixCls + "-tree-select-icon"),
    attrs: {
      "type": (!_vm.node.isLeaf && _vm.expanded) ? _vm.tree.openedIcon : _vm.tree.closedIcon
    }
  })], 1), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleUserClick($event)
      }
    }
  }, [(_vm.showCheckbox) ? _c('n3-checkbox', {
    attrs: {
      "checked": _vm.node.checked
    },
    on: {
      "change": _vm.handleCheckChange
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.node.loading) ? _c('span', {
    class: (_vm.prefixCls + "-tree-loading-box")
  }, [_c('n3-loading', {
    attrs: {
      "color": "primary",
      "size": "xs"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('n3-icon', {
    attrs: {
      "type": _vm.node.isLeaf ? _vm.tree.leafIcon : _vm.tree.childIcon
    }
  }), _vm._v(" "), _c('node-content', {
    attrs: {
      "node": _vm.node
    }
  })], 1), _vm._v(" "), _c('n3-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }]
  }, [_c('div', {
    class: (_vm.prefixCls + "-tree-children")
  }, _vm._l((_vm.node.childNodes), function(child) {
    return _c('n3-tree-node', {
      key: _vm.getNodeKey(child),
      attrs: {
        "render-content": _vm.renderContent,
        "node": child
      }
    })
  }))])])], 1)])
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-532d643c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-532d643c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Tree/n3TreeNode.vue
// module id = 625
// module chunks = 0 1